import React from "react";

export const GiftCardPurchaseModalContext = React.createContext({
    parent: null,
});